import Tixxt from "../tixxt.js";

const features = {
  Tasks: () => import("../tasks/index.js.coffee"),
  Files: () => import("../files/index.js.coffee"),
  Administration: () => import("../administration/index.js.coffee"),
  Memberships: () => import("../memberships/index.js.coffee"),
};

// Starts a given feature
// Stops the currently running feature
// does nothing if feature is already active
const startFeature = async (featureName, actionName, actionArguments) => {
  // determine requested Feature
  if (!features[featureName]) {
    throw new Error(`feature ${featureName} not found`);
  }
  await features[featureName]();
  const nextFeature = Tixxt.module(featureName);

  if (Tixxt.currentFeature !== nextFeature) {
    debug(
      `[Tixxt.startFeature] ${featureName}#${actionName}(${actionArguments
        .map((a) => JSON.stringify(a) || "undefined")
        .join(", ")})`,
    );
    // Switch Feature
    Tixxt.currentFeature?.stop();
    Tixxt.currentFeature = nextFeature;
    Tixxt.vent.trigger("change:feature", nextFeature);
    nextFeature.start({
      contentRegion: Tixxt.content,
    });
  }

  const action = nextFeature.controller[actionName];
  if (action) {
    nextFeature.controller.triggerMethod("before:action", actionName);
    Tixxt.currentAction = action;
    action.apply(nextFeature.controller, actionArguments);
    nextFeature.controller?.triggerMethod("after:action", actionName);
  } else {
    throw new Error(
      `Backbone action '${actionName}' on feature '${featureName}' not implemented`,
    );
  }
};

const stopFeature = () => {
  debug("[Tixxt.stopFeature]");
  Tixxt.currentFeature?.stop();
  Tixxt.currentFeature = null;
};

const awaitFeature = async (featureName) => {
  if (!features[featureName]) {
    throw new Error(`feature ${featureName} not found`);
  }
  await features[featureName]();
};

Tixxt.startFeature = startFeature;
Tixxt.stopFeature = stopFeature;

export { startFeature, stopFeature, awaitFeature };
